
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    orderSettleorderDetailList
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private orderNo = ''
    private keywords = ''
    private sendState = null
    private sendStatelist = [
      {value:null,label:'全部'},
      {value:true,label:'已发货'},
      {value:false,label:'待发货'},
    ]
    private signState = null
    private signStatelist = [
      {value:null,label:'全部'},
      {value:true,label:'已签收'},
      {value:false,label:'未签收'},
    ]
    private afterSale = null
    private afterSalelist = [
      {value:null,label:'全部'},
      {value:true,label:'有售后'},
      {value:false,label:'无售后'},
    ]
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0

    private mounted () {
      this.gettablelist()
    }


    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          ...this.$route.query,
          OrderNo:this.orderNo,
          ProductInfo:this.keywords,
          IsSend:this.sendState,
          IsSigned:this.signState,
          IsSupport:this.afterSale,
          FinanceOrderDetailSettleState:'',
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res:any = await orderSettleorderDetailList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.orderNo = ''
      this.keywords = ''
      this.afterSale = null
      this.sendState = null
      this.signState = null
      this.doSearch()
    }
    private exportfile(){
      let url = location.origin + '/pc/finance/orderSettle/orderDetailList'
      url += '?FinanceOrderSettleRecordId=' + (this.$route.query.FinanceOrderSettleRecordId||'')
      url += '&FinanceOrderSettleOrderDetailFromPageType=' + (this.$route.query.FinanceOrderSettleOrderDetailFromPageType||'')
      url += '&ProductId=' + (this.$route.query.ProductId||'')
      url += '&SpecValue=' + (this.$route.query.SpecValue||'')
      url += '&StartTime=' + (this.$route.query.StartTime||'')
      url += '&ProviderId=' + (this.$route.query.ProviderId||'')
      url += '&EndTime=' + (this.$route.query.EndTime||'')
      url += '&OrderNo=' + this.orderNo
      url += '&ProductInfo=' + encodeURIComponent(this.keywords)
      url += '&IsSend=' + (this.sendState==null?'':this.sendState)
      url += '&IsSigned=' + (this.signState==null?'':this.signState)
      url += '&IsSupport=' + (this.afterSale==null?'':this.afterSale)
      window.open(url)
    }
  }
